const heros = [
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl23.jpg",
        selector: "tpl23",
        liquid: "Hero1",
        magicCategory: "hero",
        version: "v1"
    },
    /*
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl1.jpg",
        selector: "tpl1",
        liquid: "Hero2",
        magicCategory: "hero"
    },
    */
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl2.jpg",
        selector: "tpl2",
        liquid: "Hero3",
        magicCategory: "hero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl3.jpg",
        selector: "tpl3",
        liquid: "Hero4",
        magicCategory: "hero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/hero36.jpg",
        selector: "hero36",
        liquid: "Hero36",
        magicCategory: "hero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl4.jpg",
        selector: "tpl4",
        liquid: "Hero5",
        magicCategory: "hero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl10.jpg",
        selector: "tpl10",
        liquid: "Hero6",
        magicCategory: "hero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl11.jpg",
        selector: "tpl11",
        liquid: "Hero7",
        magicCategory: "hero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl12.jpg",
        selector: "tpl12",
        liquid: "Hero8",
        magicCategory: "hero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/hero38a.jpg",
        selector: "hero38",
        liquid: "Hero38",
        magicCategory: "hero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl22.jpg",
        selector: "tpl22",
        liquid: "Hero9",
        magicCategory: "hero"
    },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/19.jpg",
    //     selector: "tpl19",
    //     liquid: "Hero10",
    //     magicCategory: "hero"
    // },
    // einai idia me th Hero6

    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/58.jpg",
    //     selector: "tpl58",
    //     liquid: "Hero13",
    //     magicCategory: "hero"
    // },
    // einai idia me th Hero1


    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl62.jpg",
        selector: "tpl62",
        liquid: "Hero16",
        magicCategory: "hero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl63.jpg",
        selector: "tpl63",
        liquid: "Hero17",
        magicCategory: "hero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl65.jpg",
        selector: "tpl65",
        liquid: "Hero19",
        magicCategory: "hero"
    },


    /*
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl68.jpg",
        selector: "tpl68",
        liquid: "Hero23",
        magicCategory: "hero"
    },
    */

    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl69.jpg",
        selector: "tpl69",
        liquid: "Hero24",
        magicCategory: "hero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/hero41.jpg",
        selector: "hero41",
        liquid: "Hero41",
        magicCategory: "hero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl75.jpg",
        selector: "tpl75",
        liquid: "Hero26",
        magicCategory: "hero"
    },
    /*
    {
        thumbnail : imagePath + "/author/images/pagesbuilder/81.jpg",
        selector : "tpl81"
    },
    */
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl85.jpg",
        selector: "tpl85",
        liquid: "Hero27",
        magicCategory: "hero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/hero39.jpg",
        selector: "hero39",
        liquid: "Hero39",
        magicCategory: "hero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl96.jpg",
        selector: "tpl96",
        liquid: "Hero29",
        magicCategory: "hero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl118.jpg",
        selector: "tpl118",
        liquid: "Hero31",
        magicCategory: "hero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl173.jpg",
        selector: "tpl173",
        liquid: "Hero34",
        magicCategory: "hero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/tpl43.jpg",
        selector: "tpl43",
        liquid: "Hero35",
        magicCategory: "hero"
    },

    /*
    {
        thumbnail : imagePath + "/author/images/pagesbuilder/43.jpg",
        selector : "tplProducts2",
        liquid: "Products2",
        magicCategory: "hero"
    },
    */

    /*
    {
        thumbnail : imagePath + "/author/images/pagesbuilder/43.jpg",
        selector : "tplProducts3",
        liquid: "Products3",
        magicCategory: "hero"
    },
    */

];
const videos = [
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/Video1.jpg",
        selector: "Video1",
        liquid: "Video1",
        magicCategory: "Video"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/Video2.jpg",
        selector: "Video2",
        liquid: "Video2",
        magicCategory: "Video"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/Video3.jpg",
        selector: "Video3",
        liquid: "Video3",
        magicCategory: "Video"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/Video4.jpg",
        selector: "Video4",
        liquid: "Video4",
        magicCategory: "Video"
    },

    /*
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/Video5.jpg",
        selector: "Video5",
        liquid: "Video5",
        magicCategory: "Video"
    },
    */

    {
        thumbnail: imagePath + "/author/images/pagesbuilder/Video6.jpg",
        selector: "Video6",
        liquid: "Video6",
        magicCategory: "Video"
    }
];
const courseHeros = [
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/97.jpg",
        selector: "cour-tpl97",
        liquid: "CourseHero30",
        context: "course",
        magicCategory: "courseHero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/coursehero2.jpg",
        selector: "courseHero2",
        liquid: "CourseHero32",
        context: "course",
        magicCategory: "courseHero"
    },
    /*
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/118.jpg",
        selector: "cour-tpl118",
        liquid: "CourseHero31",
        context: "course",
        magicCategory: "courseHero"
    },
    */
];
const courseContents = [
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents1.jpg",
        selector: "CourseContents1",
        liquid: "CourseContents1",
        magicCategory: "courseContents"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents2.jpg",
        selector: "CourseContents2",
        liquid: "CourseContents2",
        magicCategory: "courseContents"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents3.jpg",
        selector: "CourseContents3",
        liquid: "CourseContents3",
        magicCategory: "courseContents"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents4.jpg",
        selector: "CourseContents4",
        liquid: "CourseContents4",
        magicCategory: "courseContents"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents5.jpg",
        selector: "CourseContents5",
        liquid: "CourseContents5",
        magicCategory: "courseContents"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents6.jpg",
        selector: "CourseContents6",
        liquid: "CourseContents6",
        magicCategory: "courseContents"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents7.jpg",
        selector: "CourseContents7",
        liquid: "CourseContents7",
        magicCategory: "courseContents"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents8.jpg",
        selector: "CourseContents8",
        liquid: "CourseContents8",
        magicCategory: "courseContents"
    },

    /*
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents9.jpg",
        selector: "CourseContents9",
        liquid: "CourseContents9",
        magicCategory: "courseContents"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents10.jpg",
        selector: "CourseContents10",
        liquid: "CourseContents10",
        magicCategory: "courseContents"
    },
    */

    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents11.jpg",
        selector: "CourseContents11",
        liquid: "CourseContents11",
        magicCategory: "courseContents"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents12.jpg",
        selector: "CourseContents12",
        liquid: "CourseContents12",
        magicCategory: "courseContents"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents13.jpg",
        selector: "CourseContents13",
        liquid: "CourseContents13",
        magicCategory: "courseContents"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents14.jpg",
        selector: "CourseContents14",
        liquid: "CourseContents14",
        magicCategory: "courseContents"
    },

    /*
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents15.jpg",
        selector: "CourseContents15",
        liquid: "CourseContents15",
        magicCategory: "courseContents"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents16.jpg",
        selector: "CourseContents16",
        liquid: "CourseContents16",
        magicCategory: "courseContents"
    },
    */

    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents17.jpg",
        selector: "CourseContents17",
        liquid: "CourseContents17",
        magicCategory: "courseContents"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents18.jpg",
        selector: "CourseContents18",
        liquid: "CourseContents18",
        magicCategory: "courseContents"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents19.jpg",
        selector: "CourseContents19",
        liquid: "CourseContents19",
        magicCategory: "courseContents"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents20.jpg",
        selector: "CourseContents20",
        liquid: "CourseContents20",
        magicCategory: "courseContents"
    },

    /*
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents21.jpg",
        selector: "CourseContents21",
        liquid: "CourseContents21",
        version: "v2",
        magicCategory: "courseContents"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents22.jpg",
        selector: "CourseContents22",
        liquid: "CourseContents22",
        version: "v2",
        magicCategory: "courseContents"
    },
    */

    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents1.jpg",
    //     selector: "CourseContents1",
    //     liquid: "CourseContentsStatic1",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents2.jpg",
    //     selector: "CourseContents2",
    //     liquid: "CourseContentsStatic2",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents3.jpg",
    //     selector: "CourseContents3",
    //     liquid: "CourseContentsStatic3",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents4.jpg",
    //     selector: "CourseContents4",
    //     liquid: "CourseContentsStatic4",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents5.jpg",
    //     selector: "CourseContents5",
    //     liquid: "CourseContentsStatic5",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents6.jpg",
    //     selector: "CourseContents6",
    //     liquid: "CourseContentsStatic6",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents7.jpg",
    //     selector: "CourseContents7",
    //     liquid: "CourseContentsStatic7",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents8.jpg",
    //     selector: "CourseContents8",
    //     liquid: "CourseContentsStatic8",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents9.jpg",
    //     selector: "CourseContents9",
    //     liquid: "CourseContentsStatic9",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents10.jpg",
    //     selector: "CourseContents10",
    //     liquid: "CourseContentsStatic10",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents11.jpg",
    //     selector: "CourseContents11",
    //     liquid: "CourseContentsStatic11",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents12.jpg",
    //     selector: "CourseContents12",
    //     liquid: "CourseContentsStatic12",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents13.jpg",
    //     selector: "CourseContents13",
    //     liquid: "CourseContentsStatic13",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents14.jpg",
    //     selector: "CourseContents14",
    //     liquid: "CourseContentsStatic14",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents15.jpg",
    //     selector: "CourseContents15",
    //     liquid: "CourseContentsStatic15",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents16.jpg",
    //     selector: "CourseContents16",
    //     liquid: "CourseContentsStatic16",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents17.jpg",
    //     selector: "CourseContents17",
    //     liquid: "CourseContentsStatic17",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents18.jpg",
    //     selector: "CourseContents18",
    //     liquid: "CourseContentsStatic18",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents19.jpg",
    //     selector: "CourseContents19",
    //     liquid: "CourseContentsStatic19",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents20.jpg",
    //     selector: "CourseContents20",
    //     liquid: "CourseContentsStatic20",
    //     magicCategory: "courseContentsStatic"
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents21.jpg",
    //     selector: "CourseContents21",
    //     liquid: "CourseContentsStatic21",
    //     magicCategory: "courseContentsStatic",
    //
    // },
    // {
    //     thumbnail: imagePath + "/author/images/pagesbuilder/CourseContents22.jpg",
    //     selector: "CourseContents22",
    //     liquid: "CourseContentsStatic22",
    //     magicCategory: "courseContentsStatic",
    //     version: "v2"
    // }
];
const coursePricing = [
    /*
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/151.jpg",
        selector: "tpl151",
        liquid: "Autodata7",
        magicCategory: "coursePricing"
    },
    */
];
const bundleHeros = [
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/bundlehero1.jpg",
        selector: "bun-tpl97",
        liquid: "BundleHero1",
        context: "bundle",
        magicCategory: "bundleHero"
    },
    /*
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/118.jpg",
        selector: "bun-tpl118",
        liquid: "BundleHero2",
        context: "bundle",
        magicCategory: "bundleHero"
    },
    */
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/Hero38.jpg",
        selector: "tpl-bundle-hero-3",
        liquid: "BundleHero3",
        context: "bundle",
        magicCategory: "bundleHero"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/Hero40.jpg",
        selector: "tpl-bundle-hero-4",
        liquid: "BundleHero4",
        context: "bundle",
        magicCategory: "bundleHero"
    },
];
const bundleCourses = [
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/courses7.jpg",
        selector: "tpl-bundle-contents-1",
        liquid: "BundleContents1",
        context: "bundle",
        magicCategory: "bundleContents"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/courses8.jpg",
        selector: "tpl-bundle-contents-2",
        liquid: "BundleContents2",
        context: "bundle",
        magicCategory: "bundleContents"
    },
];
const bundleData = [
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/94.jpg",
        selector: "tpl-bundle-data-1",
        context: "bundle",
        liquid: "BundleData1",
        magicCategory: "bundleData"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/132.jpg",
        selector: "tpl-bundle-data-2",
        context: "bundle",
        liquid: "BundleData2",
        magicCategory: "bundleData"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/104.jpg",
        selector: "tpl-bundle-data-3",
        context: "bundle",
        liquid: "BundleData3",
        magicCategory: "bundleData"
    }
];
const bundleCTAs = [
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/cta6.jpg",
        selector: "tpl-bundle-cta-1",
        context: "bundle",
        liquid: "BundleCTA1",
        magicCategory: "bundleCTA"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/cta7.jpg",
        selector: "tpl-bundle-cta-2",
        context: "bundle",
        liquid: "BundleCTA2",
        magicCategory: "bundleCTA"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/cta8.jpg",
        selector: "tpl-bundle-cta-3",
        context: "bundle",
        liquid: "BundleCTA3",
        magicCategory: "bundleCTA"
    }
];
const subscriptionHeros = [
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/subscriptionshero1.jpg",
        selector: "sub-tpl97",
        liquid: "SubscriptionsHero1",
        context: "subscription",
        magicCategory: "subscriptionsHero"
    },
    /*
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/118.jpg",
        selector: "sub-tpl118",
        liquid: "SubscriptionsHero2",
        context: "subscription",
        magicCategory: "subscriptionsHero"
    }
    */
];
const subscriptionCourses = [
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/courses7.jpg",
        selector: "tpl-subscription-contents-1",
        liquid: "SubscriptionContents1",
        context: "Subscription",
        magicCategory: "subscriptionsList"
    },
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/courses8.jpg",
        selector: "tpl-subscription-contents-2",
        liquid: "SubscriptionContents2",
        context: "Subscription",
        magicCategory: "subscriptionsList"
    }
];
const subscriptionCTAs = [
    {
        thumbnail: imagePath + "/author/images/pagesbuilder/subscriptionscta1.jpg",
        selector: "tpl-subscription-purchase-1",
        liquid: "SubscriptionPurchaseCTA1",
        context: "Subscription",
        //magicCategory: "subscriptions"
    }
];

const SectionsListConfig = {

    "for-this-course-page": {
        id: "for-this-course-page",
        title: "For this course page",
        sections: [
            {
                id: "course-hero",
                title: "Course Hero",
                subsections: [
                    ...courseHeros
                ]
            },
            {
                id: "CourseContents",
                title: "Course Contents",
                subsections: [
                    ...courseContents
                ]
            }
            // {
            //     id: "course-pricing",
            //     title: "Course Pricing",
            //     subsections: [
            //         ...coursePricing
            //     ]
            // }
        ]
    },
    "for-this-bundle-page": {
        id: "for-this-bundle-page",
        title: "For this bundle page",
        sections: [
            {
                id: "bundle-hero",
                title: "Bundle Hero",
                subsections: [
                    ...bundleHeros
                ]
            },
            {
                id: "bundle-courses",
                title: "bundle Courses",
                subsections: [
                    ...bundleCourses
                ]
            },
            {
                id: "bundle-offer",
                title: "Bundle Offer",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/Hero40.jpg",
                        selector: "tpl-bundle-hero-4",
                        liquid: "BundleHero4",
                        context: "bundle",
                        magicCategory: "bundleHero"
                    },
                    ...bundleCTAs
                ]
            }
        ]
    },
    "for-this-subscription-page": {
        id: "for-this-subscription-page",
        title: "For this subscription page",
        sections: [
            {
                id: "subscriptions-hero",
                title: "Subscription Hero",
                subsections: [
                    ...subscriptionHeros
                ]
            },
            {
                id: "subscription-courses",
                title: "Subscription Courses",
                subsections: [
                    ...subscriptionCourses
                ]
            },
            {
                id: "subscription-offer",
                title: "Subscription Offer",
                subsections: [
                    ...subscriptionCTAs
                ]
            }
        ]
    },
    "for-this-affiliate-page": {
        id: "for-this-affiliate-page",
        title: "For this affiliate page",
        sections: [
            {
                id: "Affiliates",
                title: "Affiliate Registration",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/affiliate1.jpg",
                        selector: "affiliate1",
                        liquid: "AffiliatesRegistration1",
                        magicCategory: "affiliates"
                    }
                ]
            }
        ]
    },
    "Blog": {
        id: 'Blog',
        title: "Blog",
        sections: [
            {
                id: "BlogHomeHeaders",
                title: "Blog Home Headers",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/BlogHome1.jpg",
                        selector: "tplBlogHome1",
                        liquid: "BlogHome1",
                        magicCategory: "BlogHome"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/BlogHome2.jpg",
                        selector: "tplBlogHome2",
                        liquid: "BlogHome2",
                        magicCategory: "BlogHome"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/BlogHome3.jpg",
                        selector: "tplBlogHome3",
                        liquid: "BlogHome3",
                        magicCategory: "BlogHome"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/BlogHome4.jpg",
                        selector: "tplBlogHome4",
                        liquid: "BlogHome4",
                        magicCategory: "BlogHome"
                    },
                    /*
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/154.jpg",
                        selector: "tplBlogHome5",
                        liquid: "BlogHome5",
                        magicCategory: "BlogHome"
                    },
                    */
                ]
            },
            {
                id: "BlogHomePostsLists",
                title: "Blog Home Posts Lists",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/blogposts4.jpg",
                        selector: "BlogPosts4",
                        liquid: "BlogPosts4",
                        magicCategory: "blogposts"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/blogposts5.jpg",
                        selector: "BlogPosts5",
                        liquid: "BlogPosts5",
                        magicCategory: "blogposts"
                    },
                    /*
                    {
                        thumbnail : imagePath + "/author/images/pagesbuilder/25.jpg",
                        selector : "BlogPosts6",
                        liquid: "BlogPosts6",
                        magicCategory: "blogposts"
                    },
                    */
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/blogposts7.jpg",
                        selector: "BlogPosts7",
                        liquid: "BlogPosts7",
                        magicCategory: "blogposts"
                    },
                ]
            },
            {
                id: "BlogPostHero",
                title: "Blog Post Hero",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog20.jpg",
                        selector: "BlogAboveTheFold1",
                        liquid: "BlogAboveTheFold1",
                        magicCategory: "blogAboveTheFold"
                    },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/tpl165.jpg", //TextBlog5
                    //     selector: "BlogAboveTheFold2",
                    //     liquid: "BlogAboveTheFold2",
                    //     magicCategory: "blogAboveTheFold"
                    // },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog25.jpg",
                        selector: "BlogAboveTheFold3",
                        liquid: "BlogAboveTheFold3",
                        magicCategory: "blogAboveTheFold"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog6.jpg",
                        selector: "BlogAboveTheFold4",
                        liquid: "BlogAboveTheFold4",
                        magicCategory: "blogAboveTheFold"
                    },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog8.jpg",
                    //     selector: "BlogAboveTheFold5",
                    //     liquid: "BlogAboveTheFold5",
                    //     magicCategory: "blogAboveTheFold"
                    // },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/tpl196.jpg", // TextBlog24
                    //     selector: "BlogAboveTheFold6",
                    //     liquid: "BlogAboveTheFold6",
                    //     magicCategory: "blogAboveTheFold"
                    // },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog20.jpg",
                    //     selector: "blogPostsTpl10",
                    //     liquid: "TextBlog20",
                    //     magicCategory: "textBlogPost"
                    // },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/tpl165.jpg",
                    //     selector: "tpl165",
                    //     liquid: "TextBlog5",
                    //     magicCategory: "textBlogPost"
                    // },
                    //
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog6.jpg",
                    //     selector: "tpl166",
                    //     liquid: "TextBlog6",
                    //     magicCategory: "textBlogPost"
                    // },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog8.jpg",
                    //     selector: "tpl168",
                    //     liquid: "TextBlog8",
                    //     magicCategory: "textBlogPost"
                    // },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/tpl196.jpg",
                    //     selector: "tpl196",
                    //     liquid: "TextBlog24",
                    //     magicCategory: "textBlogPost"
                    // }
                ]
            },
            {
                id: "BlogPostMainText",
                title: "Blog Post Main Text",
                subsections: [

                    /*
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog25.jpg",
                        selector: "blogPostsTpl25",
                        liquid: "TextBlog25",
                        magicCategory: "textBlogPost"
                    },
                    */
                    /*
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/183.jpg",
                        selector: "blogPostsTpl11",
                        liquid: "TextBlog21",
                        magicCategory: "textBlogPost"
                    },
                    */
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog12.jpg",
                        selector: "blogPostsTpl2",
                        liquid: "TextBlog12",
                        magicCategory: "textBlogPost"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog13.jpg",
                        selector: "blogPostsTpl3",
                        liquid: "TextBlog13",
                        magicCategory: "textBlogPost"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog14.jpg",
                        selector: "blogPostsTpl4",
                        liquid: "TextBlog14",
                        magicCategory: "textBlogPost"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog17.jpg",
                        selector: "blogPostsTpl7",
                        liquid: "TextBlog17",
                        magicCategory: "textBlogPost"
                    }

                ]
            }
        ]
    },
    "Hero": {
        id: 'Hero',
        title: "Hero",
        sections: [
            {
                id: 'Hero',
                title: "Hero",
                subsections: [
                    ...heros
                ]
            }
        ]
    },
    "Products": {
        id: "Products",
        title: "Products",
        sections: [
            {
                id: "Courses",
                title: "Courses",
                subsections: [
                    {
                        id: "course-hero",
                        title: "Course Hero",
                        subsections: [
                            ...courseHeros,
                        ]
                    },
                    {
                        id: "CourseCatalogue",
                        title: "Course Catalogue",
                        subsections: [
                            ...coursePricing,
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/courses1.jpg",
                                selector: "Courses1",
                                liquid: "Courses1",
                                magicCategory: "courses"
                            },
                            /*
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/tpl128.jpg",
                                selector: "tpl128",
                                liquid: "Autodata1",
                                magicCategory: "autodata"
                            },
                            */
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/courses2.jpg",
                                selector: "Courses2",
                                liquid: "Courses2",
                                magicCategory: "courses"
                            },
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/courses3.jpg",
                                selector: "Courses3",
                                liquid: "Courses3",
                                magicCategory: "courses"
                            },
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/courses4.jpg",
                                selector: "Courses4",
                                liquid: "Courses4",
                                magicCategory: "courses"
                            },
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/courses5.jpg",
                                selector: "Courses5",
                                liquid: "Courses5",
                                magicCategory: "courses"
                            },
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/courses6.jpg",
                                selector: "Courses6",
                                liquid: "Courses6",
                                magicCategory: "courses"
                            },
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/courses11.jpg",
                                selector: "Courses11",
                                liquid: "Courses11",
                                magicCategory: "courses"
                            },
                            /*
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/courses7.jpg",
                                selector: "Courses7",
                                liquid: "Courses7",
                                magicCategory: "courses"
                            },
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/courses8.jpg",
                                selector: "Courses8",
                                liquid: "Courses8",
                                magicCategory: "courses"
                            },
                            */
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/courses9.jpg",
                                selector: "Courses9",
                                liquid: "Courses9",
                                magicCategory: "courses"
                            },
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/courses10.jpg",
                                selector: "Courses10",
                                liquid: "Courses10",
                                magicCategory: "courses"
                            },
                        ]
                    },
                    {
                        id: "CourseContents",
                        title: "Course Contents",
                        subsections: [
                            ...courseContents
                        ]
                    }
                ]
            },
            {
                id: "Dynamic-Bundles",
                title: "Bundles",
                subsections: [
                    {
                        id: "bundle-hero",
                        title: "Bundle Hero",
                        subsections: [
                            ...bundleHeros,
                        ]
                    },
                    {
                        id: "BundleCourses",
                        title: "Bundle Courses",
                        subsections: [
                            ...bundleCourses
                        ]
                    },
                    {
                        id: "BundleList",
                        title: "Bundle List",
                        subsections: [
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/bundles1.jpg",
                                selector: "Bundles1",
                                liquid: "Bundles1",
                                magicCategory: "bundles"
                            },
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/bundles2.jpg",
                                selector: "Bundles2",
                                liquid: "Bundles2",
                                magicCategory: "bundles"
                            },
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/bundles3.jpg",
                                selector: "Bundles3",
                                liquid: "Bundles3",
                                magicCategory: "bundles"
                            },
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/bundles4.jpg",
                                selector: "Bundles4",
                                liquid: "Bundles4",
                                magicCategory: "bundles"
                            },
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/bundles5.jpg",
                                selector: "Bundles5",
                                liquid: "Bundles5",
                                magicCategory: "bundles"
                            }
                        ]
                    },
                    {
                        id: "BundleOffers",
                        title: "Bundle Offers",
                        subsections: [
                            ...bundleCTAs
                        ]
                    },
                    {
                        id: "BundleData",
                        title: "Bundle Data",
                        subsections: [
                            ...bundleData
                        ]
                    },
                ]
            },
            {
                id: "Dynamic-Subscriptions",
                title: "Subscriptions",
                subsections: [
                    {
                        id: "subscription-hero",
                        title: "Subscription Hero",
                        subsections: [
                            ...subscriptionHeros,
                        ]
                    },
                    {
                        id: "SubscriptionCourses",
                        title: "Subscription Courses",
                        subsections: [
                            /*
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/159.jpg",
                                selector: "subscriptions1",
                                liquid: "Membership1",
                                magicCategory: "membership"
                            },
                            */
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/subscriptions1.jpg",
                                selector: "Subscriptions1",
                                liquid: "Subscriptions1",
                                magicCategory: "subscriptions"
                            },
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/subscriptions2.jpg",
                                selector: "Subscriptions2",
                                liquid: "Subscriptions2",
                                magicCategory: "subscriptions"
                            },
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/subscriptions3.jpg",
                                selector: "Subscriptions3",
                                liquid: "Subscriptions3",
                                magicCategory: "subscriptions"
                            },
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/subscriptions4.jpg",
                                selector: "Subscriptions4",
                                liquid: "Subscriptions4",
                                magicCategory: "subscriptions"
                            },
                            {
                                thumbnail: imagePath + "/author/images/pagesbuilder/subscriptions5.jpg",
                                selector: "Subscriptions5",
                                liquid: "Subscriptions5",
                                magicCategory: "subscriptions"
                            },
                        ]
                    },
                    {
                        id: "SubscriptionList",
                        title: "Subscription List",
                        subsections: [
                            ...subscriptionCourses

                        ]
                    },
                    {
                        id: "SubscriptionOffer",
                        title: "Subscription Offer",
                        subsections: [
                            ...subscriptionCTAs,

                        ]
                    },
                ]
            }
        ]
    },
    "MediaText": {
        id: "MediaText",
        title: "Media & Text",
        sections: [
            {
                id: "MediaText",
                title: "Media & Text",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/Video1.jpg",
                        selector: "Video1",
                        liquid: "Video1",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/Video2.jpg",
                        selector: "Video2",
                        liquid: "Video2",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/Video3.jpg",
                        selector: "Video3",
                        liquid: "Video3",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/Video4.jpg",
                        selector: "Video4",
                        liquid: "Video4",
                        magicCategory: "mediaText"
                    },

                    /*
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/Video5.jpg",
                        selector: "Video5",
                        liquid: "Video5",
                        magicCategory: "Video"
                    },
                    */

                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/Video6.jpg",
                        selector: "Video6",
                        liquid: "Video6",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl67n.jpg",
                        selector: "tpl67",
                        liquid: "Hero22",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl86.jpg",
                        selector: "tpl86",
                        liquid: "Hero28",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl142.jpg",
                        selector: "tpl142",
                        liquid: "Hero32",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl42.jpg",
                        selector: "tpl42",
                        liquid: "Hero12",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/167.jpg",
                        selector: "tpl167",
                        liquid: "TextBlog7",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/blogPostsTpl5.jpg",
                        selector: "blogPostsTpl5",
                        liquid: "TextBlog15",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/178.jpg",
                        selector: "blogPostsTpl6",
                        liquid: "TextBlog16",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/180.jpg",
                        selector: "blogPostsTpl8",
                        liquid: "TextBlog18",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/blogPostsTpl9.jpg",
                        selector: "blogPostsTpl9",
                        liquid: "TextBlog19",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tplMediaText26.jpg",
                        selector: "tplMediaText26",
                        liquid: "MediaText26",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl99.jpg",
                        selector: "tpl99",
                        liquid: "MediaText3",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl119.jpg",
                        selector: "tpl119",
                        liquid: "MediaText11",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/122.jpg",
                        selector: "tpl122",
                        liquid: "MediaText14",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl144.jpg",
                        selector: "tpl144",
                        liquid: "MediaText17",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/MediaText27.jpg",
                        selector: "tplMediaText27",
                        liquid: "MediaText27",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl124.jpg",
                        selector: "tpl124",
                        liquid: "MediaText7",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl30.jpg",
                        selector: "tpl30",
                        liquid: "MediaText22",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl32.jpg",
                        selector: "tpl32",
                        liquid: "MediaText24",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl74.jpg",
                        selector: "tpl74",
                        liquid: "MediaText2",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl16.jpg",
                        selector: "tpl16",
                        liquid: "MediaText20",
                        magicCategory: "mediaText"
                    },

                    /*
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl125.jpg",
                        selector: "tpl125",
                        liquid: "MediaText8",
                        magicCategory: "mediaText"
                    },
                    */

                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl140.jpg",
                        selector: "tpl140",
                        liquid: "MediaText16",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl138.jpg",
                        selector: "tpl138",
                        liquid: "MediaText15",
                        magicCategory: "mediaText"
                    },

                    /*
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl145.jpg",
                        selector: "tpl145",
                        liquid: "MediaText18",
                        magicCategory: "mediaText"
                    },
                    */

                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl15.jpg",
                        selector: "tpl15",
                        liquid: "MediaText19",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl73.jpg",
                        selector: "tplMediaText1",
                        liquid: "MediaText1",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/164.jpg",
                        selector: "tpl164",
                        liquid: "MediaText10",
                        magicCategory: "mediaText"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl115.jpg",
                        selector: "tpl115",
                        liquid: "MediaText13",
                        magicCategory: "mediaText"
                    },


                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/107.jpg",
                    //     selector: "tpl107",
                    //     liquid: "MediaText4",
                    //     magicCategory: "mediaText"
                    // },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/108.jpg",
                    //     selector: "tpl108",
                    //     liquid: "MediaText5",
                    //     magicCategory: "mediaText"
                    // },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/123.jpg",
                    //     selector: "tpl123",
                    //     liquid: "MediaText6",
                    //     magicCategory: "mediaText"
                    // },


                    /*
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl158.jpg",
                        selector: "tpl158",
                        liquid: "MediaText9",
                        magicCategory: "mediaText"
                    },
                    */





                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/29.jpg",
                    //     selector: "tpl29",
                    //     liquid: "MediaText21",
                    //     magicCategory: "mediaText"
                    // },


                    /*
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/31.jpg",
                        selector: "tpl31",
                        liquid: "MediaText23",
                        magicCategory: "mediaText"
                    },
                    */


                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/MediaText28.jpg",
                    //     selector: "tplMediaText28",
                    //     liquid: "MediaText28",
                    //     magicCategory: "mediaText"
                    // }

                    //{
                    //thumbnail : imagePath + "/author/images/pagesbuilder/33.jpg",
                    //selector : "tpl33",
                    //liquid: "MediaText25",
                    //magicCategory: "mediaText"
                    //}
                ]
            },

            /*
            {
                id: "Video",
                title: "Video",
                subsections: [
                    ...videos
                ]
            },
            */


            {
                id: "MeetingsWebinars",
                title: "Meetings & Webinars",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/134.jpg",
                        selector: "tpl134",
                        liquid: "Meetings1",
                        magicCategory: "meetings"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl77.jpg",
                        selector: "tpl77",
                        liquid: "Meetings2",
                        magicCategory: "meetings"
                    }
                ]
            }
        ]
    },
    /*
    "TextsAndBlogPosts": {
        id: "TextsAndBlogPosts",
        title: "Texts & Blog Posts",
        sections: [
            {
                id: "TextsAndBlogPosts",
                title: "Texts & Blog Posts",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/154.jpg",
                        selector: "tpl154",
                        liquid: "TextBlog3",
                        magicCategory: "textBlogPost"
                    },
                    // {
                    //     thumbnail : imagePath + "/author/images/pagesbuilder/163.jpg",
                    //     selector : "tpl163",
                    //     liquid: "TextBlog4",
                    //     magicCategory: "textBlogPost"
                    // },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl165.jpg",
                        selector: "tpl165",
                        liquid: "TextBlog5",
                        magicCategory: "textBlogPost"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/166.jpg",
                        selector: "tpl166",
                        liquid: "TextBlog6",
                        magicCategory: "textBlogPost"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/168.jpg",
                        selector: "tpl168",
                        liquid: "TextBlog8",
                        magicCategory: "textBlogPost"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl196.jpg",
                        selector: "tpl196",
                        liquid: "TextBlog24",
                        magicCategory: "textBlogPost"
                    },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/133.jpg",
                    //     selector: "tpl133",
                    //     liquid: "TextBlog9",
                    //     magicCategory: "textBlogPost"
                    // },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/141.jpg",
                    //     selector: "tpl141",
                    //     liquid: "TextBlog10",
                    //     magicCategory: "textBlogPost"
                    // },
                    // {
                    //     thumbnail : imagePath + "/author/images/pagesbuilder/76.jpg",
                    //     selector : "blogPostsTpl1",
                    //     liquid: "TextBlog11",
                    //     magicCategory: "textBlogPost"
                    // },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/174.jpg",
                        selector: "blogPostsTpl2",
                        liquid: "TextBlog12",
                        magicCategory: "textBlogPost"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/175.jpg",
                        selector: "blogPostsTpl3",
                        liquid: "TextBlog13",
                        magicCategory: "textBlogPost"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/176.jpg",
                        selector: "blogPostsTpl4",
                        liquid: "TextBlog14",
                        magicCategory: "textBlogPost"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/179.jpg",
                        selector: "blogPostsTpl7",
                        liquid: "TextBlog17",
                        magicCategory: "textBlogPost"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/78.jpg",
                        selector: "blogPostsTpl10",
                        liquid: "TextBlog20",
                        magicCategory: "textBlogPost"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/183.jpg",
                        selector: "blogPostsTpl11",
                        liquid: "TextBlog21",
                        magicCategory: "textBlogPost"
                    },
                    // {
                    //     thumbnail : imagePath + "/author/images/pagesbuilder/184.jpg",
                    //     selector : "blogPostsTpl12",
                    //     liquid: "TextBlog22",
                    //     magicCategory: "textBlogPost"
                    // },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/185.jpg",
                    //     selector: "blogPostsTpl13",
                    //     liquid: "TextBlog23",
                    //     magicCategory: "textBlogPost"
                    // }
                ]

            }
        ]
    },
    */

    /*
    "Video": {
        id: "Video",
        title: "Video",
        sections: [
            {
                id: "Video",
                title: "Video",
                subsections: [
                    ...videos
                ]
            },
        ]
    },
    */

    "ColumnsLists": {
        id: "ColumnsLists",
        title: "Columns & Lists",
        sections: [
            {
                id: "ColumnsLists",
                title: "Columns & Lists",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl64.jpg",
                        selector: "tpl64",
                        liquid: "Hero18",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl66.jpg",
                        selector: "tpl66",
                        liquid: "Hero20",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/hero21.jpg",
                        selector: "tpl66Mirror",
                        liquid: "Hero21",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl60.jpg",
                        selector: "tpl60",
                        liquid: "Hero14",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl61.jpg",
                        selector: "tpl61",
                        liquid: "Hero15",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl143.jpg",
                        selector: "tpl143",
                        liquid: "Hero33",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/9.jpg",
                        selector: "tpl9",
                        liquid: "Quotes6",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/col35.jpg",
                        selector: "col35",
                        liquid: "ColumnsLists35",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl13.jpg",
                        selector: "tpl13",
                        liquid: "ColumnsLists4",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl7.jpg",
                        selector: "tpl7",
                        liquid: "ColumnsLists5",
                        magicCategory: "columnsLists"
                    },

                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl18.jpg",
                        selector: "tpl18",
                        liquid: "ColumnsLists7",
                        magicCategory: "columnsLists"
                    },

                    /*
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/26.jpg",
                        selector: "tpl26",
                        liquid: "ColumnsLists8",
                        magicCategory: "columnsLists"
                    },
                    */
                    /*
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/38.jpg",
                        selector: "tpl38",
                        liquid: "ColumnsLists9",
                        magicCategory: "columnsLists"
                    },
                    */

                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl40.jpg",
                        selector: "tpl40",
                        liquid: "ColumnsLists10",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl41.jpg",
                        selector: "tpl41",
                        liquid: "ColumnsLists11",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl82.jpg",
                        selector: "tpl82",
                        liquid: "ColumnsLists12",
                        magicCategory: "columnsLists"
                    },

                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl102.jpg",
                        selector: "tpl102",
                        liquid: "ColumnsLists14",
                        magicCategory: "columnsLists"
                    },

                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl135.jpg",
                        selector: "tpl135",
                        liquid: "ColumnsLists17",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/col34-b.jpg",
                        selector: "col34",
                        liquid: "ColumnsLists34",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl17.jpg",
                        selector: "tpl17",
                        liquid: "ColumnsLists6",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/col32.jpg",
                        selector: "col32",
                        liquid: "ColumnsLists32",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl76.jpg",
                        selector: "tpl76",
                        liquid: "ColumnsLists19",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/col31.jpg",
                        selector: "col31",
                        liquid: "ColumnsLists31",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl94.jpg",
                        selector: "tpl94",
                        liquid: "ColumnsLists1",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl132.jpg",
                        selector: "tpl132",
                        liquid: "ColumnsLists2",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl104.jpg",
                        selector: "tpl104",
                        liquid: "ColumnsLists3",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl100.jpg",
                        selector: "tpl100",
                        liquid: "ColumnsLists13",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl110.jpg",
                        selector: "tpl110",
                        liquid: "ColumnsLists16",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl103.jpg",
                        selector: "tpl103",
                        liquid: "ColumnsLists15",
                        magicCategory: "columnsLists"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/col36.jpg",
                        selector: "col36",
                        liquid: "ColumnsLists36",
                        magicCategory: "columnsLists"
                    }
                ]
            }
        ]
    },
    "CTAs": {
        id: "CTAs",
        title: "CTAs",
        sections: [
            {
                id: "CTAs",
                title: "CTAs",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl95.jpg",
                        selector: "tpl95",
                        liquid: "CTA1",
                        magicCategory: "cta"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl114.jpg",
                        selector: "tpl114",
                        liquid: "CTA2",
                        magicCategory: "cta"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl37.jpg",
                        selector: "tpl37",
                        liquid: "CTA3",
                        magicCategory: "cta"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/cta4.jpg",
                        selector: "cta4",
                        liquid: "CTA4",
                        magicCategory: "cta"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/cta5.jpg",
                        selector: "cta5",
                        liquid: "CTA5",
                        magicCategory: "cta"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/cta6.jpg",
                        selector: "cta6",
                        liquid: "CTA6",
                        magicCategory: "cta"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/cta7.jpg",
                        selector: "cta7",
                        liquid: "CTA7",
                        magicCategory: "cta"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/cta8.jpg",
                        selector: "cta8",
                        liquid: "CTA8",
                        magicCategory: "cta"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/cta9.jpg",
                        selector: "cta9",
                        liquid: "CTA9",
                        magicCategory: "cta"
                    },

                    /*
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl22.jpg",
                        selector: "tpl22",
                        liquid: "Hero9",
                        magicCategory: "cta"
                    },
                    */

                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl70.jpg",
                        selector: "tpl70",
                        liquid: "Hero25",
                        magicCategory: "cta"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl97.jpg",
                        selector: "tpl97",
                        liquid: "Hero30",
                        magicCategory: "cta"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tplHero40.jpg",
                        selector: "tplHero40",
                        liquid: "Hero40",
                        magicCategory: "cta"
                    }

                ]
            }

            /*
            {
                id: "Hero",
                title: "Hero",
                subsections: [
                    ...heros
                ]
            }
            */
        ]
    },
    "Payments": {
        id: "Payments",
        title: "Payments",
        sections: [
            {
                id: "Payments",
                title: "Payments",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/157.jpg",
                        selector: "Checkout",
                        liquid: "Checkout1",
                        magicCategory: "checkout"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/thankyou1.jpg",
                        selector: "Thankyou1",
                        liquid: "Thankyou1",
                        magicCategory: "thankYou"
                    }
                ]
            }
        ]
    },
    "TestimonialsQuotes": {
        id: "TestimonialsQuotes",
        title: "Persons & Quotes",
        sections: [
            {
                id: "TestimonialsQuotes",
                title: "Persons & Quotes",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl146.jpg",
                        selector: "tpl146",
                        liquid: "ColumnsLists18",
                        magicCategory: "quotes"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/col33.jpg",
                        selector: "col33",
                        liquid: "ColumnsLists33",
                        magicCategory: "quotes"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/author1.jpg",
                        selector: "Author1",
                        liquid: "Author1",
                        magicCategory: "quotes"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/89.jpg",
                        selector: "tpl89",
                        liquid: "Quotes1",
                        magicCategory: "quotes"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/92.jpg",
                        selector: "tpl92",
                        liquid: "Quotes2",
                        magicCategory: "quotes"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/persons2.jpg",
                        selector: "persons2",
                        liquid: "Quotes9",
                        magicCategory: "quotes"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/106.jpg",
                        selector: "tpl106",
                        liquid: "Quotes3",
                        magicCategory: "quotes"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/121.jpg",
                        selector: "tpl121",
                        liquid: "Quotes4",
                        magicCategory: "quotes"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl113.jpg",
                        selector: "tpl113",
                        liquid: "MediaText12",
                        magicCategory: "quotes"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/136.jpg",
                        selector: "tpl136",
                        liquid: "Quotes5",
                        magicCategory: "quotes"
                    },
                    // {
                    //     thumbnail : imagePath + "/author/images/pagesbuilder/8.jpg",
                    //     selector : "tpl8",
                    //     liquid: "Quotes6"
                    // },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/80.jpg",
                        selector: "tpl80",
                        liquid: "Quotes7",
                        magicCategory: "quotes"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/persons1.jpg",
                        selector: "persons1",
                        liquid: "Quotes8",
                        magicCategory: "quotes"
                    }
                ]
            }
        ]
    },
    "GalleriesGrids": {
        id: "GalleriesGrids",
        title: "Galleries & Grids",
        sections: [
            {
                id: "GalleriesGrids",
                title: "Galleries & Grids",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/90.jpg",
                        selector: "tpl90",
                        liquid: "Gallery1",
                        magicCategory: "gallery"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/55.jpg",
                        selector: "tpl55",
                        liquid: "Gallery2",
                        magicCategory: "gallery"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/56.jpg",
                        selector: "tpl56",
                        liquid: "Gallery3",
                        magicCategory: "gallery"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/57.jpg",
                        selector: "tpl57",
                        liquid: "Gallery4",
                        magicCategory: "gallery"
                    },

                    /*
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/56.jpg",
                        selector: "tplGallery5",
                        liquid: "Gallery5",
                        magicCategory: "gallery"
                    }
                    */
                ]
            }
        ]
    },
    "FAQs": {
        id: "FAQs",
        title: "FAQs",
        sections: [
            {
                id: "FAQs",
                title: "FAQs",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl153.jpg",
                        selector: "tpl153",
                        liquid: "FAQ1",
                        magicCategory: "faq"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/faq2.jpg",
                        selector: "faq2",
                        liquid: "FAQ2",
                        magicCategory: "faq"
                    },

                    /*
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/faq3.jpg",
                        selector: "faq3",
                        liquid: "FAQ3",
                        magicCategory: "faq"
                    },
                    */

                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/faq4.jpg",
                        selector: "faq4",
                        liquid: "FAQ4",
                        magicCategory: "faq"
                    }
                ]
            }
        ]
    },
    "OffersCoupons": {
        id: "OffersCoupons",
        title: "Offers",
        sections: [
            {
                id: "OffersCoupons",
                title: "Offers & Coupons",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/101.jpg",
                        selector: "tpl101",
                        liquid: "Offers1",
                        magicCategory: "offers"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/197.jpg",
                        selector: "tpl197",
                        liquid: "Offers2",
                        magicCategory: "offers"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/198.jpg",
                        selector: "tpl198",
                        liquid: "Offers3",
                        magicCategory: "offers"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/offer4.jpg",
                        selector: "Offer4",
                        liquid: "Offers4",
                        magicCategory: "offers"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/offer5.jpg",
                        selector: "Offers5",
                        liquid: "Offers5",
                        magicCategory: "offers"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/offer6.jpg",
                        selector: "Offers6",
                        liquid: "Offers6",
                        magicCategory: "offers"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/offer7.jpg",
                        selector: "Offers7",
                        liquid: "Offers7",
                        magicCategory: "offers"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/offer8.jpg",
                        selector: "Offers8",
                        liquid: "Offers8",
                        magicCategory: "offers"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/offer9.jpg",
                        selector: "Offers9",
                        liquid: "Offers9",
                        magicCategory: "offers"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/offer10.jpg",
                        selector: "Offers10",
                        liquid: "Offers10",
                        magicCategory: "offers"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/offer11.jpg",
                        selector: "Offers11",
                        liquid: "Offers11",
                        magicCategory: "offers"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/offer12.jpg",
                        selector: "Offers12",
                        liquid: "Offers12",
                        magicCategory: "offers"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/offer13.jpg",
                        selector: "Offers13",
                        liquid: "Offers13",
                        magicCategory: "offers"
                    }
                ]
            }

        ]
    },
    "Prelaunch": {
        id: "Prelaunch",
        title: "Prelaunch",
        sections: [
            {
                id: "Prelaunch",
                title: "Prelaunch",
                subsections: [
                    /*
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/155.jpg",
                        selector: "tpl155",
                        liquid: "Prelaunch1",
                        magicCategory: "prelaunch"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/170.jpg",
                        selector: "tpl170",
                        liquid: "Prelaunch2",
                        magicCategory: "prelaunch"
                    },
                    */
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/prelaunch3.jpg",
                        selector: "prelaunch3",
                        liquid: "Prelaunch3",
                        magicCategory: "prelaunch"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/prelaunch4.jpg",
                        selector: "prelaunch4",
                        liquid: "Prelaunch4",
                        magicCategory: "prelaunch"
                    }
                ]
            }
        ]
    },
    // "Timer" : {
    //     id: "Timer",
    //     title: "Timer",
    //     sections: [
    //         {
    //             id: "Timer",
    //             title: "Timer",
    //             subsections: [
    //                 {
    //                     thumbnail: imagePath + "/author/images/pagesbuilder/timer-placeholder-image.png",
    //                     selector: "timer1",
    //                     liquid: "Timer1",
    //                     magicCategory: "timer"
    //                 }
    //             ]
    //         }
    //     ]
    // },
    "PricingTables": {
        id: "PricingTables",
        title: "Pricing Tables",
        sections: [
            {
                id: "PricingTables",
                title: "Pricing Tables",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/109.jpg",
                        selector: "tpl109",
                        liquid: "PricingTable1",
                        magicCategory: "pricingTable"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/117.jpg",
                        selector: "tpl117",
                        liquid: "PricingTable2",
                        magicCategory: "pricingTable"
                    }
                ]
            }
        ]
    },
    "user-oriented": {
        id: "user-oriented",
        title: "Student Info",
        sections: [
            {
                id: "user-oriented",
                title: "Student Info",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/128.jpg",
                        selector: "tpl128",
                        liquid: "Autodata1",
                        magicCategory: "autodata"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/129.jpg",
                        selector: "tpl129",
                        liquid: "Autodata2",
                        magicCategory: "autodata"
                    },
                    // {
                    //     thumbnail : imagePath + "/author/images/pagesbuilder/156.jpg",
                    //     selector : "tpl156",
                    //     liquid: "Autodata3",
                    //     magicCategory: "autodata"
                    // },
                    // {
                    //     thumbnail : imagePath + "/author/images/pagesbuilder/182.jpg",
                    //     selector : "tpl182",
                    //     liquid: "Autodata4",
                    //     magicCategory: "autodata"
                    // },
                    // {
                    //     thumbnail : imagePath + "/author/images/pagesbuilder/169.jpg",
                    //     selector : "tpl169",
                    //     liquid: "Autodata5",
                    //     magicCategory: "autodata"
                    // },
                    // {
                    //     thumbnail : imagePath + "/author/images/pagesbuilder/149.jpg",
                    //     selector : "tpl149",
                    //     liquid: "Autodata6",
                    //     magicCategory: "autodata"
                    // },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/151.jpg",
                    //     selector: "tpl151",
                    //     liquid: "Autodata7",
                    //     magicCategory: "autodata"
                    // },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/152.jpg",
                        selector: "tpl152",
                        liquid: "Autodata8",
                        magicCategory: "autodata"
                    }
                ]
            }
        ]
    },
    "EmailGrabbers": {
        id: "EmailGrabbers",
        title: "Email Grabbers",
        sections: [
            {
                id: "EmailGrabbers",
                title: "Email Grabbers",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl71.jpg",
                        selector: "tpl71",
                        liquid: "EmailLead1",
                        magicCategory: "emailLead"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl59.jpg",
                        selector: "tpl59",
                        liquid: "EmailLead2",
                        magicCategory: "emailLead"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl88.jpg",
                        selector: "tpl88",
                        liquid: "EmailLead3",
                        magicCategory: "emailLead"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl93.jpg",
                        selector: "tpl93",
                        liquid: "EmailLead4",
                        magicCategory: "emailLead"
                    },

                    /*
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl137.jpg",
                        selector: "tpl137",
                        liquid: "EmailLead5",
                        magicCategory: "emailLead"
                    },
                    */

                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl28.jpg",
                        selector: "tpl28",
                        liquid: "EmailLead6",
                        magicCategory: "emailLead"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl72.jpg",
                        selector: "tpl72",
                        liquid: "EmailLead7",
                        magicCategory: "emailLead"
                    }
                ]
            }
        ]
    },
    "ContactForms": {
        id: "ContactForms",
        title: "Contact Forms",
        sections: [
            {
                id: "ContactForms",
                title: "Contact Forms",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl147.jpg",
                        selector: "tpl147",
                        liquid: "Contact1",
                        magicCategory: "contact"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/tpl35.jpg",
                        selector: "tpl35",
                        liquid: "Contact2",
                        magicCategory: "contact"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/contact3.jpg",
                        selector: "contact3",
                        liquid: "Contact3",
                        magicCategory: "contact"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/contact4.jpg",
                        selector: "contact4",
                        liquid: "Contact4",
                        magicCategory: "contact"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/contact5.jpg",
                        selector: "contact5",
                        liquid: "Contact5",
                        magicCategory: "contact"
                    }
                ]
            }
        ]
    },
    "Embed": {
        id: "Embed",
        title: "Embed",
        sections: [
            {
                id: "Embed",
                title: "Embed",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/embed1.jpg",
                        selector: "embed1",
                        liquid: "Embed1",
                        magicCategory: "embed"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/embed2.jpg",
                        selector: "embed2",
                        liquid: "Embed2",
                        magicCategory: "embed"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/embed3.jpg",
                        selector: "embed3",
                        liquid: "Embed3",
                        magicCategory: "embed"
                    },
                ]
            }
        ]
    },
    "Apps": {
        id: "Apps",
        title: "Apps",
        sections: [
            {
                id: "Dynamic-Community-Posts",
                title: "Community posts",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/communityposts1.jpg",
                        selector: "CommunityPosts1",
                        liquid: "CommunityPosts1",
                        magicCategory: "community"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/communityposts2.jpg",
                        selector: "CommunityPosts2",
                        liquid: "CommunityPosts2",
                        magicCategory: "community"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/communityposts3.jpg",
                        selector: "CommunityPosts3",
                        liquid: "CommunityPosts3",
                        magicCategory: "community"
                    }
                ]
            },
            {
                id: "BlogPosts",
                title: "Blog posts",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/blogposts1a.jpg",
                        selector: "BlogPosts1",
                        liquid: "BlogPosts1",
                        magicCategory: "blogposts"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/blogposts2a.jpg",
                        selector: "BlogPosts2",
                        liquid: "BlogPosts2",
                        magicCategory: "blogposts"
                    },
                    // {
                    //     id: "BlogPostMainText",
                    //     title: "Blog Post Main Text",
                    //     subsections: [
                    //         {
                    //             thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog25.jpg",
                    //             selector: "blogPostsTpl25",
                    //             liquid: "TextBlog25",
                    //             magicCategory: "textBlogPost"
                    //         },
                    //         /*
                    //         {
                    //             thumbnail: imagePath + "/author/images/pagesbuilder/183.jpg",
                    //             selector: "blogPostsTpl11",
                    //             liquid: "TextBlog21",
                    //             magicCategory: "textBlogPost"
                    //         },
                    //         */
                    //         {
                    //             thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog1.jpg",
                    //             selector: "TextBlog1",
                    //             liquid: "TextBlog1",
                    //             magicCategory: "textBlogPost"
                    //         },
                    //         {
                    //             thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog2.jpg",
                    //             selector: "TextBlog2",
                    //             liquid: "TextBlog2",
                    //             magicCategory: "textBlogPost"
                    //         },
                    //         {
                    //             thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog12.jpg",
                    //             selector: "blogPostsTpl2",
                    //             liquid: "TextBlog12",
                    //             magicCategory: "textBlogPost"
                    //         },
                    //         {
                    //             thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog13.jpg",
                    //             selector: "blogPostsTpl3",
                    //             liquid: "TextBlog13",
                    //             magicCategory: "textBlogPost"
                    //         },
                    //         {
                    //             thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog14.jpg",
                    //             selector: "blogPostsTpl4",
                    //             liquid: "TextBlog14",
                    //             magicCategory: "textBlogPost"
                    //         },
                    //         {
                    //             thumbnail: imagePath + "/author/images/pagesbuilder/TextBlog17.jpg",
                    //             selector: "blogPostsTpl7",
                    //             liquid: "TextBlog17",
                    //             magicCategory: "textBlogPost"
                    //         }

                    //     ]
                    //     thumbnail : imagePath + "/author/images/pagesbuilder/25.jpg",
                    //     selector : "BlogPosts3",
                    //     liquid: "BlogPosts3",
                    //     magicCategory: "blogposts"
                    // },
                ]

            },
            {
                id: "Dynamic-Daily-news",
                title: "Daily news",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/dailyNews1.jpg",
                        selector: "DailyNews1",
                        liquid: "DailyNews1",
                        magicCategory: "dailyNews"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/dailyNews2.jpg",
                        selector: "DailyNews2",
                        liquid: "DailyNews2",
                        magicCategory: "dailyNews"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/dailyNews3.jpg",
                        selector: "DailyNews3",
                        liquid: "DailyNews3",
                        magicCategory: "dailyNews"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/dailynews4.jpg",
                        selector: "DailyNews4",
                        liquid: "DailyNews4",
                        magicCategory: "dailyNews"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/dailynews5.jpg",
                        selector: "DailyNews5",
                        liquid: "DailyNews5",
                        magicCategory: "dailyNews"
                    }
                ]
            }
        ]
    },
    "Empty Layouts": {
        id: "Empty-Layouts",
        title: "Build your own Layout",
        sections: [
            {
                id: "Empty-Layouts",
                title: "Empty Layouts",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/ColumnsLists20.jpg",
                        selector: "tplColumnsLists20",
                        liquid: "ColumnsLists20",
                        magicCategory: "emptyLayouts"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/ColumnsLists21.jpg",
                        selector: "tplColumnsLists21",
                        liquid: "ColumnsLists21",
                        magicCategory: "emptyLayouts"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/ColumnsLists22.jpg",
                        selector: "tplColumnsLists22",
                        liquid: "ColumnsLists22",
                        magicCategory: "emptyLayouts"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/ColumnsLists23.jpg",
                        selector: "tplColumnsLists23",
                        liquid: "ColumnsLists23",
                        magicCategory: "emptyLayouts"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/ColumnsLists24.jpg",
                        selector: "tplColumnsLists24",
                        liquid: "ColumnsLists24",
                        magicCategory: "emptyLayouts"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/ColumnsLists25.jpg",
                        selector: "tplColumnsLists25",
                        liquid: "ColumnsLists25",
                        magicCategory: "emptyLayouts"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/ColumnsLists26.jpg",
                        selector: "tplColumnsLists26",
                        liquid: "ColumnsLists26",
                        magicCategory: "emptyLayouts"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/ColumnsLists27.jpg",
                        selector: "tplColumnsLists27",
                        liquid: "ColumnsLists27",
                        magicCategory: "emptyLayouts"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/ColumnsLists28.jpg",
                        selector: "tplColumnsLists28",
                        liquid: "ColumnsLists28",
                        magicCategory: "emptyLayouts"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/ColumnsLists29.jpg",
                        selector: "tplColumnsLists29",
                        liquid: "ColumnsLists29",
                        magicCategory: "emptyLayouts"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/ColumnsLists30.jpg",
                        selector: "tplColumnsLists30",
                        liquid: "ColumnsLists30",
                        magicCategory: "emptyLayouts"
                    }
                ]
            }
        ]
    },

    /* Excluded from everywhere */
    /*"MeetingsWebinars" : {
        id: "MeetingsWebinars",
        title: "Meetings & Webinars",
        sections : [
            {
                id: "MeetingsWebinars",
                title: "Meetings & Webinars",
                subsections: [
                    {
                        thumbnail : imagePath + "/author/images/pagesbuilder/134.jpg",
                        selector : "tpl134",
                        liquid: "Meetings1",
                        magicCategory: "meetings"
                    },
                    {
                        thumbnail : imagePath + "/author/images/pagesbuilder/77.jpg",
                        selector : "tpl77",
                        liquid: "Meetings2",
                        magicCategory: "meetings"
                    }
                ]
            }
        ]
    },*/
    "LoginForms": {
        id: "LoginForms",
        title: "Login Forms",
        sections: []
    },
    // "Courses" : {
    //     title: "Courses",
    //     sections : [
    //         {
    //             id: "Courses",
    //             title: "Courses",
    //             subsections: [
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/courses1.jpg",
    //                     selector : "Courses1",
    //                     liquid: "Courses1",
    //                     magicCategory: "courses"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/courses2.jpg",
    //                     selector : "Courses2",
    //                     liquid: "Courses2",
    //                     magicCategory: "courses"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/courses3.jpg",
    //                     selector : "Courses3",
    //                     liquid: "Courses3",
    //                     magicCategory: "courses"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/courses4.jpg",
    //                     selector : "Courses4",
    //                     liquid: "Courses4",
    //                     magicCategory: "courses"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/courses5.jpg",
    //                     selector : "Courses5",
    //                     liquid: "Courses5",
    //                     magicCategory: "courses"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/courses6.jpg",
    //                     selector : "Courses6",
    //                     liquid: "Courses6",
    //                     magicCategory: "courses"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/courses11.jpg",
    //                     selector : "Courses11",
    //                     liquid: "Courses11",
    //                     magicCategory: "courses"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/courses7.jpg",
    //                     selector : "Courses7",
    //                     liquid: "Courses7",
    //                     magicCategory: "courses"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/courses8.jpg",
    //                     selector : "Courses8",
    //                     liquid: "Courses8",
    //                     magicCategory: "courses"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/courses9.jpg",
    //                     selector : "Courses9",
    //                     liquid: "Courses9",
    //                     magicCategory: "courses"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/courses10.jpg",
    //                     selector : "Courses10",
    //                     liquid: "Courses10",
    //                     magicCategory: "courses"
    //                 }
    //             ]
    //         }
    //     ]
    // },


    // "Memberships" : {
    //     title: "Memberships",
    //     sections : [
    //         {
    //             title: "Memberships",
    //             subsections: [
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/159.jpg",
    //                     selector : "subscriptions1",
    //                     liquid: "Membership1",
    //                     magicCategory: "membership"
    //                 }
    //             ]
    //         }
    //     ]
    // },
    // "One-clickSales" : {
    //     title: "One-click Sales",
    //     sections : [
    //         {
    //             title: "One-click Sales",
    //             subsections: [
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/105.jpg",
    //                     selector : "tpl105",
    //                     liquid: "OneClickSales1",
    //                     magicCategory: "oneClickSales"
    //                 }
    //             ]
    //         }
    //     ]
    // },
    // "Checkout" : {
    //     title: "Checkout",
    //     sections : [
    //         {
    //             title: "Checkout",
    //             subsections: [
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/157.jpg",
    //                     selector : "Checkout1",
    //                     liquid: "Checkout1",
    //                     magicCategory: "checkout"
    //                 }
    //             ]
    //         }
    //     ]
    // },
    /*
    "Dynamic-Courses" : {
        title: "Courses auto",
        sections : [
            {
                thumbnail : imagePath + "/author/images/pagesbuilder/87.jpg",
                selector : "Courses1",
                liquid: "Courses1",
                magicCategory: "courses"
            },
            {
                thumbnail : imagePath + "/author/images/pagesbuilder/98.jpg",
                selector : "Courses2",
                liquid: "Courses2",
                magicCategory: "courses"
            },
            {
                thumbnail : imagePath + "/author/images/pagesbuilder/127.jpg",
                selector : "Courses3",
                liquid: "Courses3",
                magicCategory: "courses"
            },
            {
                thumbnail : imagePath + "/author/images/pagesbuilder/162.jpg",
                selector : "Courses4",
                liquid: "Courses4",
                magicCategory: "courses"
            },
            {
                thumbnail : imagePath + "/author/images/pagesbuilder/116.jpg",
                selector : "Courses5",
                liquid: "Courses5",
                magicCategory: "courses"
            },
            {
                thumbnail : imagePath + "/author/images/pagesbuilder/139.jpg",
                selector : "Courses6",
                liquid: "Courses6",
                magicCategory: "courses"
            },
            {
                thumbnail : imagePath + "/author/images/pagesbuilder/Courses7.jpg",
                selector : "Courses7",
                liquid: "Courses7",
                magicCategory: "courses"
            },
            {
                thumbnail : imagePath + "/author/images/pagesbuilder/Courses8.jpg",
                selector : "Courses8",
                liquid: "Courses8",
                magicCategory: "courses"
            }
        ]
    },
    */
    // "Dynamic-Bundles" : {
    //     title: "Bundles auto",
    //     sections : [
    //         {
    //             title: "Bundles auto",
    //             subsections: [
    //                 {
    //                     thumbnail: imagePath + "/author/images/pagesbuilder/97.jpg",
    //                     selector: "bun-tpl97",
    //                     liquid: "BundleHero1",
    //                     context: "bundle",
    //                     magicCategory: "bundleHero"
    //                 },
    //                 {
    //                     thumbnail: imagePath + "/author/images/pagesbuilder/118.jpg",
    //                     selector: "bun-tpl118",
    //                     liquid: "BundleHero2",
    //                     context: "bundle",
    //                     magicCategory: "bundleHero"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/Hero38.jpg",
    //                     selector : "tpl-bundle-hero-3",
    //                     liquid: "BundleHero3",
    //                     context: "bundle",
    //                     magicCategory: "bundleHero"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/Hero40.jpg",
    //                     selector : "tpl-bundle-hero-4",
    //                     liquid: "BundleHero4",
    //                     context: "bundle",
    //                     magicCategory: "bundleHero"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/131.jpg",
    //                     selector : "Bundles1",
    //                     liquid: "Bundles1",
    //                     magicCategory: "bundles"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/150.jpg",
    //                     selector : "Bundles2",
    //                     liquid: "Bundles2",
    //                     magicCategory: "bundles"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/courses7.jpg",
    //                     selector : "tpl-bundle-contents-1",
    //                     liquid: "BundleContents1",
    //                     context: "bundle",
    //                     magicCategory: "bundleContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/courses8.jpg",
    //                     selector : "tpl-bundle-contents-2",
    //                     liquid: "BundleContents2",
    //                     context: "bundle",
    //                     magicCategory: "bundleContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/cta6.jpg",
    //                     selector : "tpl-bundle-cta-1",
    //                     context: "bundle",
    //                     liquid: "BundleCTA1",
    //                     magicCategory: "bundleCTA"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/cta7.jpg",
    //                     selector : "tpl-bundle-cta-2",
    //                     context: "bundle",
    //                     liquid: "BundleCTA2",
    //                     magicCategory: "bundleCTA"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/cta8.jpg",
    //                     selector : "tpl-bundle-cta-3",
    //                     context: "bundle",
    //                     liquid: "BundleCTA3",
    //                     magicCategory: "bundleCTA"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/94.jpg",
    //                     selector : "tpl-bundle-data-1",
    //                     context: "bundle",
    //                     liquid: "BundleData1",
    //                     magicCategory: "bundleData"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/132.jpg",
    //                     selector : "tpl-bundle-data-2",
    //                     context: "bundle",
    //                     liquid: "BundleData2",
    //                     magicCategory: "bundleData"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/104.jpg",
    //                     selector : "tpl-bundle-data-3",
    //                     context: "bundle",
    //                     liquid: "BundleData3",
    //                     magicCategory: "bundleData"
    //                 },
    //             ]
    //         }
    //     ]
    // },
    // "Dynamic-Subscriptions" : {
    //     title: "Subscriptions auto",
    //     sections : [
    //         {
    //             title: "Subscriptions auto",
    //             subsections: [
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/159.jpg",
    //                     selector : "Subscriptions1",
    //                     liquid: "Subscriptions1",
    //                     magicCategory: "subscriptions"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/159-b.jpg",
    //                     selector : "Subscriptions2",
    //                     liquid: "Subscriptions2",
    //
    //                     magicCategory: "subscriptions"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/courses7.jpg",
    //                     selector : "tpl-subscription-contents-1",
    //                     liquid: "SubscriptionContents1",
    //                     context: "Subscription",
    //                     magicCategory: "subscriptions"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/courses8.jpg",
    //                     selector : "tpl-subscription-contents-2",
    //                     liquid: "SubscriptionContents2",
    //                     context: "Subscription",
    //                     magicCategory: "subscriptions"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/114.jpg",
    //                     selector : "tpl-subscription-purchase-1",
    //                     liquid: "SubscriptionPurchaseCTA1",
    //                     context: "Subscription",
    //                     magicCategory: "subscriptions"
    //                 },
    //             ]
    //         }
    //     ]
    // },
    // "Dynamic-Community-Posts" : {
    //     id: "Dynamic-Community-Posts",
    //     title: "Community posts auto",
    //     sections : [
    //         {
    //             id: "Dynamic-Community-Posts",
    //             title: "Community posts auto",
    //             subsections: [
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/communityposts1.jpg",
    //                     selector : "CommunityPosts1",
    //                     liquid: "CommunityPosts1",
    //                     magicCategory: "community"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/communityposts2.jpg",
    //                     selector : "CommunityPosts2",
    //                     liquid: "CommunityPosts2",
    //                     magicCategory: "community"
    //                 }
    //             ]
    //         }
    //     ]
    // },
    // "Dynamic-Course-Contents" : {
    //     id: "Dynamic-Course-Contents",
    //     title: "Course contents auto",
    //     sections : [
    //         {
    //             id: "Dynamic-Course-Contents",
    //             title: "Course contents auto",
    //             subsections: [
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents1.jpg",
    //                     selector : "CourseContents1",
    //                     liquid: "CourseContents1",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents2.jpg",
    //                     selector : "CourseContents2",
    //                     liquid: "CourseContents2",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents3.jpg",
    //                     selector : "CourseContents3",
    //                     liquid: "CourseContents3",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents4.jpg",
    //                     selector : "CourseContents4",
    //                     liquid: "CourseContents4",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents5.jpg",
    //                     selector : "CourseContents5",
    //                     liquid: "CourseContents5",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents6.jpg",
    //                     selector : "CourseContents6",
    //                     liquid: "CourseContents6",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents7.jpg",
    //                     selector : "CourseContents7",
    //                     liquid: "CourseContents7",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents8.jpg",
    //                     selector : "CourseContents8",
    //                     liquid: "CourseContents8",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents9.jpg",
    //                     selector : "CourseContents9",
    //                     liquid: "CourseContents9",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents10.jpg",
    //                     selector : "CourseContents10",
    //                     liquid: "CourseContents10",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents11.jpg",
    //                     selector : "CourseContents11",
    //                     liquid: "CourseContents11",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents12.jpg",
    //                     selector : "CourseContents12",
    //                     liquid: "CourseContents12",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents13.jpg",
    //                     selector : "CourseContents13",
    //                     liquid: "CourseContents13",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents14.jpg",
    //                     selector : "CourseContents14",
    //                     liquid: "CourseContents14",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents15.jpg",
    //                     selector : "CourseContents15",
    //                     liquid: "CourseContents15",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents16.jpg",
    //                     selector : "CourseContents16",
    //                     liquid: "CourseContents16",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents17.jpg",
    //                     selector : "CourseContents17",
    //                     liquid: "CourseContents17",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents18.jpg",
    //                     selector : "CourseContents18",
    //                     liquid: "CourseContents18",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents19.jpg",
    //                     selector : "CourseContents19",
    //                     liquid: "CourseContents19",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents20.jpg",
    //                     selector : "CourseContents20",
    //                     liquid: "CourseContents20",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents21.jpg",
    //                     selector : "CourseContents21",
    //                     liquid: "CourseContents21",
    //                     version: "v2",
    //                     magicCategory: "courseContents"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/CourseContents22.jpg",
    //                     selector : "CourseContents22",
    //                     liquid: "CourseContents22",
    //                     version: "v2",
    //                     magicCategory: "courseContents"
    //                 }
    //             ]
    //         }
    //     ]
    // },
    // "Dynamic-Daily-news" : {
    //     id: "Dynamic-Daily-news",
    //     title: "Daily news auto",
    //     sections : [
    //         {
    //             id: "Dynamic-Daily-news",
    //             title: "Daily news auto",
    //             subsections: [
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/dailyNews1.jpg",
    //                     selector : "DailyNews1",
    //                     liquid: "DailyNews1",
    //                     magicCategory: "dailyNews"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/dailyNews2.jpg",
    //                     selector : "DailyNews2",
    //                     liquid: "DailyNews2",
    //                     magicCategory: "dailyNews"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/dailyNews3.jpg",
    //                     selector : "DailyNews3",
    //                     liquid: "DailyNews3",
    //                     magicCategory: "dailyNews"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/dailynews4.jpg",
    //                     selector : "DailyNews4",
    //                     liquid: "DailyNews4",
    //                     magicCategory: "dailyNews"
    //                 },
    //                 {
    //                     thumbnail : imagePath + "/author/images/pagesbuilder/dailynews5.jpg",
    //                     selector : "DailyNews5",
    //                     liquid: "DailyNews5",
    //                     magicCategory: "dailyNews"
    //                 }
    //             ]
    //         }
    //     ]
    // },

    "Affiliates": {
        id: "Affiliates",
        title: "Affiliate Registration",
        sections: [
            {
                id: "Affiliates",
                title: "Affiliate Registration",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/affiliate1.jpg",
                        selector: "tpl73",
                        liquid: "AffiliatesRegistration1",
                        magicCategory: "affiliates"
                    }
                ]
            }
        ]
    },
    // "Dynamic" : {
    //     title: "Dynamic",
    //     sections : [
    // {
    //     thumbnail : imagePath + "/author/images/pagesbuilder/25.jpg",
    //     selector : "BlogAboveTheFold1",
    //     liquid: "BlogAboveTheFold1",
    //     // magicCategory: "courseOverview"
    // },
    // {
    //     thumbnail : imagePath + "/author/images/pagesbuilder/25.jpg",
    //     selector : "BlogPosts1",
    //     liquid: "BlogPosts1",
    //     // magicCategory: "courseOverview"
    // },
    // {
    //     thumbnail : imagePath + "/author/images/pagesbuilder/25.jpg",
    //     selector : "tpl25",
    //     liquid: "Courses11",
    //     magicCategory: "courses"
    // },
    // {
    //     thumbnail : imagePath + "/author/images/pagesbuilder/25.jpg",
    //     selector : "tpl83",
    //     liquid: "Courses12",
    //     magicCategory: "courses"
    // },
    // {
    //     thumbnail : imagePath + "/author/images/pagesbuilder/25.jpg",
    //     selector : "bundlesTpl1",
    //     liquid: "Bundles3",
    //     magicCategory: "bundles"
    // },
    // {
    //     thumbnail : imagePath + "/author/images/pagesbuilder/25.jpg",
    //     selector : "CommunityPostsTpl1",
    //     liquid: "CommunityPosts1",
    //     magicCategory: "community"
    // },
    // {
    //     thumbnail : imagePath + "/author/images/pagesbuilder/25.jpg",
    //     selector : "CourseContentsTpl1",
    //     liquid: "CourseContents3",
    //     magicCategory: "courseContents"
    // },
    // {
    //     thumbnail : imagePath + "/author/images/pagesbuilder/25.jpg",
    //     selector : "subscriptionTpl1",
    //     liquid: "Subscriptions1",
    //     magicCategory: "subscriptions"
    // },
    // {
    //     thumbnail : imagePath + "/author/images/pagesbuilder/25.jpg",
    //     selector : "dailyNewsTpl1",
    //     liquid: "DailyNews1",
    //     magicCategory: "dailyNews"
    // }
    //     ]
    // },
    "Topbar": {
        id: "Topbar",
        title: "Topbar",
        sections: [
            {
                id: "Topbar",
                title: "Topbar",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/topbar1.jpg",
                        selector: "topbar1",
                        liquid: "Topbar1",
                        magicCategory: "topbar"
                    },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/topbar2.jpg",
                    //     selector: "topbar2",
                    //     liquid: "Topbar2",
                    //     magicCategory: "topbar"
                    // },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/topbar3.jpg",
                    //     selector: "topbar3",
                    //     liquid: "Topbar3",
                    //     magicCategory: "topbar"
                    // },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/topbar4.jpg",
                    //     selector: "topbar4",
                    //     liquid: "Topbar4",
                    //     magicCategory: "topbar"
                    // },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/topbar5.jpg",
                    //     selector: "topbar5",
                    //     liquid: "Topbar5",
                    //     magicCategory: "topbar"
                    // },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/topbar6.jpg",
                        selector: "topbar6",
                        liquid: "Topbar6",
                        magicCategory: "topbar"
                    },
                    // {
                    //     thumbnail: imagePath + "/author/images/pagesbuilder/topbar7.jpg",
                    //     selector: "topbar7",
                    //     liquid: "Topbar7",
                    //     magicCategory: "topbar"
                    // }
                    // {
                    //     thumbnail : imagePath + "/author/images/pagesbuilder/53.jpg",
                    //     selector : "tpl53",
                    //     liquid: "Topbar5",
                    //     magicCategory: "topbar"
                    //
                    // },
                    // {
                    //     thumbnail : imagePath + "/author/images/pagesbuilder/54.jpg",
                    //     selector : "tpl54",
                    //     liquid: "Topbar6",
                    //     magicCategory: "topbar"
                    // }
                ]
            }
        ]
    },
    "Footer": {
        id: "Footer",
        title: "Footer",
        sections: [
            {
                id: "Footer",
                title: "Footer",
                subsections: [
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/44.jpg",
                        selector: "tpl44",
                        liquid: "Footer1",
                        magicCategory: "footer"
                    },
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/45.jpg",
                        selector: "tpl45",
                        liquid: "Footer2",
                        magicCategory: "footer"
                    },
                    /*
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/46.jpg",
                        selector: "tpl46",
                        liquid: "Footer3",
                        magicCategory: "footer"
                    },
                    */
                    {
                        thumbnail: imagePath + "/author/images/pagesbuilder/47.jpg",
                        selector: "tpl47",
                        liquid: "Footer4",
                        magicCategory: "footer"
                    }
                ]
            }
        ]
    }
}

export {SectionsListConfig}
